<template>
  <hel-module title="企业经营核心指标" :class="scope.clsPrefix">
    <div class="indicators-container">
      <div class="indicators-main">
        <div class="indicator-item" v-for="(item, index) in indicators" :key="index" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1">
        <div class="indicator-header">
          <span class="indicator-name">{{ item.name }}</span>
          <span :class="['indicator-trend', item.trendClass]">
            <span class="trend-value">环比 {{ item.trendValue }}</span>
          </span>
        </div>
        <div class="indicator-value">
          <span class="value-num">{{ item.value }}</span>
          <span class="value-unit">{{ item.unit }}</span>
        </div>
        <div class="indicator-mask" v-show="hoverIndex === index">
          <button class="smart-analysis-btn" @click.stop="handleSmartAnalysis(item)">智能分析</button>
        </div>
      </div>
      </div>

    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'
export default {
  name: 'BusinessIndicators',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-business-indicators'
      },
      hoverIndex: -1,
      // 2025年8月 mock 数据（来自环比对比明细表）
      indicators: [
        {
          name: '当月收入',
          value: '11,824.60',
          unit: '万',
          trendValue: '-21.2%',
          trendClass: 'trend-down' // 收入下降 → 红色
        },
        {
          name: '当月利润',
          value: '2,022.00',
          unit: '万',
          trendValue: '-50.8%',
          trendClass: 'trend-down' // 利润下降 → 红色
        },
        {
          name: '当月成本',
          value: '9,802.60',
          unit: '万',
          trendValue: '-19.8%',
          trendClass: 'trend-up' // 成本下降 → 绿色（好事）
        },
        {
          name: '毛利率',
          value: '17.1',
          unit: '%',
          trendValue: '-1.6%',
          trendClass: 'trend-down', // 毛利率下降 → 红色
          highlight: true
        },
        {
          name: '客户订单',
          value: '51',
          unit: '单',
          trendValue: '+14.5%',
          trendClass: 'trend-up' // 订单增长 → 绿色
        },
        {
          name: '当月产量',
          value: '8,624',
          unit: '台',
          trendValue: '+25.2%',
          trendClass: 'trend-up' // 产量增长 → 绿色
        }
        // {
        //   name: '销售费用',
        //   value: '643.2',
        //   unit: '万',
        //   trendValue: '+201.8%',
        //   trendClass: 'trend-down' // 费用上升 → 红色（坏事）
        // }
      ]
    }
  },
  created() {
    this.fetchBaseMetrics()
  },
  mounted() {},
  methods: {
    handleSmartAnalysis(item) {
      // 毛利率：保留原有 demo 流程（runProfitMarginAbnormalAnalysis）
      // 其他指标：只打开抽屉，不触发任何问答/分析
      if (item.name === '毛利率') {
        this.$emit('smart-analysis', item)
      } else {
        this.$emit('smart-analysis', { ...item, silentOpenDrawer: true })
      }
    },
    formatValue(value, indicatorName) {
      if (indicatorName === '毛利率') {
        return value.toFixed(1)
      }
      if (indicatorName === '客户订单') {
        return Math.round(value).toLocaleString()
      }
      // 当月产量：接口值单位即为吨，取整 + 千分位
      if (indicatorName === '当月产量') {
        return Math.round(value).toLocaleString()
      }
      // 收入 / 成本 / 利润：统一以万元为单位，保留两位小数
      if (indicatorName === '当月收入' || indicatorName === '当月成本' || indicatorName === '当月利润') {
        return (value / 10000).toFixed(2)
      }
      if (value >= 100000000) {
        return (value / 100000000).toFixed(1)
      } else if (value >= 10000) {
        return (value / 10000).toFixed(1)
      } else {
        return value.toFixed(1)
        // return value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    getUnit(value, indicatorName) {
      if (indicatorName === '毛利率') {
        return '%'
      }
      if (indicatorName === '客户订单' || indicatorName === '本月产量') {
        return ''
      }
      // 当月产量：吨
      if (indicatorName === '当月产量') {
        return '台'
      }
      // 收入 / 成本 / 利润：统一万元
      if (indicatorName === '当月收入' || indicatorName === '当月成本' || indicatorName === '当月利润') {
        return '万'
      }
      if (value >= 100000000) {
        return '亿'
      } else if (value >= 10000) {
        return '万'
      } else {
        return '元'
      }
    },
    getTrendInfo(growthRate, indicatorName) {
      growthRate = Number(growthRate)
      // 成本/费用类指标：上升为坏事（红），下降为好事（绿）
      const isReverse = indicatorName === '当月成本' || indicatorName === '销售费用'
      if (growthRate > 0) {
        return {
          trendValue: `+${growthRate.toFixed(1)}%`,
          trendClass: isReverse ? 'trend-down' : 'trend-up',
          trendIcon: '↑'
        }
      } else if (growthRate < 0) {
        return {
          trendValue: `${growthRate.toFixed(1)}%`,
          trendClass: isReverse ? 'trend-up' : 'trend-down',
          trendIcon: '↓'
        }
      } else {
        return {
          trendValue: '0.0%',
          trendClass: 'trend-flat',
          trendIcon: '→'
        }
      }
    },
    async fetchBaseMetrics() {
      try {
        const now = new Date()
        const year = now.getFullYear().toString()
        const month = (now.getMonth()).toString()
        const response = await axios.post(
          'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/erp/baseMetrics',
          {
            secret: '9k0NVP',
            paramList: [
              { paramName: 'year', paramValue: year },
              { paramName: 'month', paramValue: month }
            ]
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        console.log('接口返回数据:', response.data)
        const { data } = response.data
        if (data && data.length > 0) {
          const metrics = data[0]
          const fields = [
            'revenue',
            'revenue_growth_rate',
            'profit',
            'profit_growth_rate',
            'cost',
            'cost_growth_rate',
            'gross_margin',
            'gross_margin_change_pct_pts',
            'orders_num',
            'orders_num_growth_rate',
            'production',
            'production_growth_rate',
            'sales_expense',
            'sales_expense_growth_rate'
          ]

          this.indicators.forEach((indicator, index) => {
            const valueIndex = index * 2
            const trendIndex = index * 2 + 1

            if (valueIndex < fields.length) {
              const value = Number(metrics[fields[valueIndex]])
              indicator.value = this.formatValue(value, indicator.name)
              indicator.unit = this.getUnit(value, indicator.name)
            }

            if (trendIndex < fields.length) {
              const growthRate = metrics[fields[trendIndex]]
              const trend = this.getTrendInfo(growthRate, indicator.name)
              indicator.trendValue = trend.trendValue
              indicator.trendClass = trend.trendClass
              indicator.trendIcon = trend.trendIcon
            }
          })
        }
      } catch (error) {
        console.error('获取企业经营核心指标失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-business-indicators";
.indicators-main {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  margin-bottom: 8px;
}
.#{$class-prefix} {
  overflow: hidden;
  .indicators-container {
    // height: 116px;
    height: 100%;
    width: 100%;
    // overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: transparent;
  }
  .indicators-container:hover {
    scrollbar-width: thin;
    scrollbar-color: #b0b0b0 #e8e8e8;
  }
  .indicator-item {
    // flex: 0 0 auto;
    // width: 180px;
    min-width: 120px;
    flex: 1;
    // width: calc(100% / 7);
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: #EFF2FC;
    // align-items: center;
    justify-content: space-between;
    padding: 16px;
    height: 106px;
    position: relative;
    // border-right: 1px solid #f0f0f0;
    // &:last-child {
    //   border-right: none;
    // }
    .indicator-header {
      display: flex;
      flex-direction: column;
      // align-items: center;
      // justify-content: center;
      // gap: 2px;
      margin-bottom: 8px;
    }
    .indicator-name {
      font-size: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
      margin-bottom: 4px;
    }
    .indicator-trend {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      &.trend-up {
        color: #73B950;
      }
      &.trend-down {
        color: #F44F4F;
      }
      &.trend-flat {
        color: #F4B13D;
      }
    }
    .trend-value {
      font-weight: 500;
    }
    .indicator-value {
      display: flex;
      align-items: baseline;
      gap: 8px;
    }
    .value-num {
      font-size: 24px;
      font-weight: 700;
      font-family: PingFangSC-Semibold;
      color: #333;
      line-height: 32px;
    }
    &.is-highlight .value-num {
      color: #F44F4F; /* 毛利率等需标红的指标数字 */
    }
    .value-unit {
      font-size: 12px;
      color: #333;
      font-weight: 400;
    }
    .indicator-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #edf1fb3b;
      backdrop-filter: blur(1px);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      // transition: opacity 0.2s ease;
    }
    .smart-analysis-btn {
      width: 64px;
      height: 24px;
      border: none;
      background-image: linear-gradient(270deg, #4A5FF3 0%, #4E86FF 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 12px;
      // &:hover {
      //   background: #F0F2FF;
      // }
    }
  }
}
@media screen and (max-width: 1440px) {
  .#{$class-prefix} {
    .indicator-item {
      .value-num {
        font-size: 18px;
      }
      .indicator-name {
        font-size: 11px;
      }
    }
  }
}
</style>

<style lang="scss">
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar {
  height: 0;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container:hover::-webkit-scrollbar {
  height: 6px;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar-track {
  background: #e8e8e8;
  border-radius: 3px;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border-radius: 3px;
}
.rvc-cosmoplat-workspace-business-indicators .indicators-container::-webkit-scrollbar-thumb:hover {
  background: #909090;
}
</style>
